/* eslint-disable ember/classic-decorator-hooks, ember/no-computed-properties-in-native-classes */
import EmberObject, { computed, set } from '@ember/object';

import * as CommonUtils from '../../utils/common';
import * as ArrayUtils from '../utils/array';
import * as ConversionUtils from '../utils/conversion';

export default class TargetStage extends EmberObject {
  previousStage = null;
  filterFrequencyRange = null;
  filter;
  optimization = null;
  toleranceInput = null;
  stageQ;
  stageFp;
  stageFz = 1;
  gain;
  stageId = null;
  stageType = null;
  stageLetter = null;
  index = null;
  timeAxis = null;
  selectedImplementation = null;
  frequencyArray = null;
  stage = 0; // TODO: Believed not used? Carries the order, weirdly - probably a typo. Supplied to suppress TypeScript error. Examine use in narrow-band.ts

  init() {
    if (!CommonUtils.isNullOrUndefined(this.filterFrequencyRange))
      set(this, 'frequencyArray', this.filterFrequencyRange.friendlyFrequencyArray);
  }

  @computed('stageFp', 'gain') get isHighSpeedHighGainStage() {
    var stageFp = this.stageFp;
    var gain = this.gain;
    return gain >= 10 && stageFp > 1e6;
  }

  @computed('filter', 'gain') get impulseArrayFirstElement() {
    var filter = this.filter;
    var gain = this.gain;
    var result = filter.getImpulseArrayFirstElement(gain);
    return result;
  }

  @computed('impulseArrayFirstElement', 'timeAxis', 'stepResponseIdeal') get impulseResponse() {
    var impulseArrayFirstElement = this.impulseArrayFirstElement;
    var timeAxis = this.timeAxis;
    var stepResponseIdealArray = this.stepResponseIdeal;
    var firstPoint = stepResponseIdealArray[0];
    var result = [impulseArrayFirstElement];
    for (var i = 1; i < timeAxis.length; i++) {
      var secondPoint = stepResponseIdealArray[i];
      result.push(secondPoint - firstPoint);
      firstPoint = secondPoint;
    }

    return result;
  }

  @computed('frequencyArray', 'filter', 'stageFp', 'stageQ', 'gain') get filterAmplitude() {
    var base = this;
    var frequencyArray = base.frequencyArray;
    var fp = base.stageFp;
    var Q = base.stageQ;
    var gain = base.gain;
    var result = this.createAmplitude(fp, Q, gain, frequencyArray);

    return result;
  }

  @computed('filterAmplitude') get magnitude() {
    var filterAmplitude = this.filterAmplitude;
    var result = filterAmplitude.map((item) => {
      var magnitude = item.magnitude();
      return magnitude;
    });

    return result;
  }

  @computed('filterAmplitude') get phase() {
    var filterAmplitude = this.filterAmplitude;
    var result = filterAmplitude.map((item) => {
      var phase = Math.atan2(item.imaginary, item.real);
      return phase;
    });

    return result;
  }

  @computed('order') get ordinal() {
    var order = this.order;
    var result = CommonUtils.toOrdinal(order);
    return result;
  }

  @computed('stageType') get stageTypeDisplay() {
    var stageType = this.stageType;
    var result = CommonUtils.displayStageType(stageType);
    return result;
  }

  @computed('magnitude', 'frequencyArray') get chart() {
    var magnitude = this.magnitude;
    var frequencyArray = this.frequencyArray;
    var dbData = ConversionUtils.VVarrtoDBarr(magnitude);
    var result = ArrayUtils.joinArrays(frequencyArray, dbData);
    return result;
  }
}
